import distributorAgentDailyReport from './distributorAgentDailyReport';
import distributorAgentMonthlyReport from './distributorAgentMonthlyReport';

export default {
  dailyReport: distributorAgentDailyReport,
  monthlyReport: distributorAgentMonthlyReport,
};
